import { AxiosError } from 'axios';

/**
 * Properly logs Axios errors with response data
 * This is especially useful for debugging API errors during build time
 */
export const logAxiosError = (error: unknown): void => {
  if (error instanceof Error && 'isAxiosError' in error) {
    const axiosError = error as AxiosError;

    const errorInfo = {
      message: axiosError.message,
      code: axiosError.code,
      status: axiosError.response?.status,
      statusText: axiosError.response?.statusText,
      url: axiosError.config?.url,
      method: axiosError.config?.method,
      // This is the key part - stringify the response data body
      responseData: axiosError.response?.data,
      headers: axiosError.response?.headers,
    };

    console.error('Axios Error Details:', JSON.stringify(errorInfo, null, 2));
  } else {
    console.error('Error:', error);
  }
};
